import { regExp, TParameters } from '../types';
import { readRouteParameters, writeRouteParameters, writeQueryParameters } from './parameters';

/**
 * concatenate the route and query uri and ensure proper encoding
 */
export function finalizeURI(routeURI: string, queryURI: string) {
  const _routeURI = routeURI.replace(regExp.manySlashes, '/').replace(':', ':/');
  const _queryURI = queryURI ? `?${queryURI}` : '';

  // not handled by encodeURIComponent, but exposes the uri to an injection bug
  return `${encodeURI(_routeURI)}${_queryURI}`.replace(regExp.fixSingleQuotes, '%27');
}

/**
 * mix in parameters for routes and query parameters
 */
export function writeURI(uri: string, params: TParameters = {}) {
  const [route, query] = uri.split('?');

  const routeParameterList = readRouteParameters(route);
  const routeURI = writeRouteParameters(route, routeParameterList, params);
  const queryString = writeQueryParameters(query, routeParameterList, params);

  return finalizeURI(routeURI, queryString);
}

/**
 *
 *
 * @example
 * pre: ['/111?a=1', '/222?b=2', '/333?c=3']
 * post: '111/222/333?a=1&b=2&c=3'
 *
 * there are two potentials issues:
 * - two strings have the same variable
 * - the expectation is that we will not add string
 */
export function concatenateURI(uri: string[]): string {
  const paths: string[] = [];
  const params: string[] = [];

  uri.forEach(function (uriPart) {
    const [path, param] = uriPart.split('?');

    if (path != null) {
      paths.push(path || '');
    }

    if (param != null) {
      params.push(param || '');
    }
  });

  const parameters = params.length > 0 ? `?${params.join('&')}` : '';

  return `${paths.join('/')}${parameters}`;
}
